import { render, staticRenderFns } from "./PredefinedScriptList.vue?vue&type=template&id=6b3ff54c"
import script from "./PredefinedScriptList.vue?vue&type=script&lang=js"
export * from "./PredefinedScriptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports